<template>
  <el-dialog
    width="80%"
    title="Информация для формирования счета"
    class="dialog--save-nomenclature--without-scan"
    :before-close="closeModal"
    :visible.sync="visible"
    append-to-body
    @open="openModal"
  >
    <el-form
      ref="form"
      :model="formData"
      label-width="180px"
      label-position="top"
    >
      <el-row v-if="page === 'report'" :gutter="24">
        <el-col :span="16">
          <el-form-item label="Номенклатура">
            <el-input v-model="formData.cargo" size="mini" autocomplete="off" />
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label="Номер отчета">
            <el-input
              v-model="formData.number"
              size="mini"
              autocomplete="off"
            />
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label="Маршрут">
            <el-input v-model="formData.route" size="mini" autocomplete="off" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="5">
          <el-form-item label="Что выгружать:">
            <el-checkbox-group v-model="checkedScoupe">
              <el-checkbox
                v-for="(value, index) in formData.scopes"
                :key="index"
                :label="index"
              >
                {{ value }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <div class="watermarks-list--checkbox">
            <div class="item">
              <el-form-item
                v-show="checkedScoupe.find(scoupe => scoupe === 'acts')"
                label="С печатью копия верна?"
                class="select--watermark"
              >
                <el-select
                  v-model="checkedWatermarks.acts"
                  placeholder="Выберите из списка"
                  size="mini"
                  clearable
                  style="width: 170px"
                >
                  <el-option
                    v-for="item in formData.watermarks.acts"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </div>

            <div class="item">
              <el-form-item
                v-show="checkedScoupe.find(scoupe => scoupe === 'ttns')"
                label="С печатью копия верна?"
                class="select--watermark"
              >
                <el-select
                  v-model="checkedWatermarks.ttns"
                  placeholder="Выберите из списка"
                  size="mini"
                  clearable
                  style="width: 170px"
                >
                  <el-option
                    v-for="item in formData.watermarks.ttns"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="watermarks-list--checkbox">
            <div
              v-for="(value, index) in formData.combine"
              :key="index"
              class="item"
            >
              <el-form-item
                v-show="checkedScoupe.find(scoupe => scoupe === index)"
                label="Комбайн?"
                class="select--watermark"
              >
                <el-select
                  v-model="checkedCombine[index]"
                  placeholder="Выберите из списка"
                  size="mini"
                  clearable
                  style="width: 170px"
                >
                  <el-option
                    v-for="item in formData.combine[index]"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <div
        style="display: flex; align-items: center; justify-content: flex-end"
      >
        <el-checkbox
          v-model="isBlackWhite"
          style="margin-right: 12px; margin-top: 15px"
        >
          скачать договоры и акты в чб
        </el-checkbox>

        <el-button
          type="primary"
          :disabled="progressBar.is"
          @click="onSaveNomenclatureHandler"
        >
          Сформировать
        </el-button>
      </div>
      <div v-if="progressBar.start" class="progress-bar--container">
        <div class="progress-bar--text">
          Скачивание начнется автоматически сразу после формирования отчета на
          сервере.

          <div v-if="statusDownload === 'ready'">
            <span class="bold">
              Отчет сформирован. Если скачивание не началось автоматически.
              Перейдите по ссылке.
            </span>
            <a target="_blank" :href="linkDownload">{{ linkDownload }}</a>
          </div>
          <div v-if="statusDownload !== 'ready'">
            Если файл не смог сформироваться полностью, нажмите эту
            <el-link
              class="reload-link"
              type="danger"
              @click.native="reloadDownloadReport"
            >
              ссылку
            </el-link>
            для переформироваться
          </div>
        </div>

        <progress-bar
          v-if="progressBar.is"
          color="#67C23A"
          :time="10000"
          :start="true"
        />
      </div>
    </div>
  </el-dialog>
</template>

<script>
import index from '@/components/Forms/FormSaveNomenclature/mixins'

export default {
  name: 'FormSaveNomenclatureWithoutScan',
  mixins: [index],
  props: {
    curBid: {
      type: Number,
      default: null,
    },
  },
}
</script>

<style lang="sass">
.dialog--save-nomenclature--without-scan
  font-family: 'Rubik', sans-serif
  & .el-dialog
    &__title
      font-weight: 500
    & .reload-link
      & span
        margin-top: 0
        margin-bottom: 0
        line-height: 15px

  & .select--watermark
    display: flex
    align-items: center

    &:first-child
      margin-top: 0
      margin-bottom: 0

    & .el-form-item__label
      padding: 0
      font-weight: 300
      line-height: 35px

    & .el-form-item__content
      width: 200px
      display: inline-block

  .watermarks-list--checkbox
    display: flex
    margin-top: 50px
    flex-direction: column

    & .item
      height: 35px

  & .el-form-item__label
    font-weight: 500

  & .el-checkbox
    font-weight: 300

    &__label
      font-size: 16px
      line-height: 35px
</style>
